import React, { useEffect, Dispatch, SetStateAction } from 'react';
import styles from './request-table-account-tab.module.scss';
import { useOfflineReportsActions } from 'store/offline-reports/use-offline-reports-actions';
import { useOfflineReportsAccountRequestsLoading, useOfflineReportsAccountRequests } from './hooks';

import RequestsTable from '../requests-table/requests-table';
import { Loading } from 'ui-components/loading/loading-component';
import { TableActiveTab } from 'core/entities/offline-reports/offline-reports';

type PopupButtonProps = {
    setIsCustomLoading: Dispatch<SetStateAction<boolean>>;
    setRequestId: Dispatch<SetStateAction<string | null>>;
    searchValue: string;
    activeTab: TableActiveTab;
};

export const AccountRequestTable = ({
    setIsCustomLoading,
    searchValue,
    setRequestId,
    activeTab,
}: PopupButtonProps) => {
    const { getOfflineReportsAccount } = useOfflineReportsActions();
    const isLoading = useOfflineReportsAccountRequestsLoading();
    const accountsRequests = useOfflineReportsAccountRequests();

    useEffect(() => {
        getOfflineReportsAccount();
    }, [getOfflineReportsAccount]);

    useEffect(() => {
        !isLoading && setIsCustomLoading(false);
    });

    return (
        <div className={styles.sharingButtonsWrapper}>
            <Loading show={isLoading} className={styles.accountCasesLoading}>
                <RequestsTable
                    searchValue={searchValue}
                    setRequestId={setRequestId}
                    requests={accountsRequests}
                    showAccountMaterials
                    activeTab={activeTab}
                />
            </Loading>
        </div>
    );
};
